import React from 'react';
import PropTypes from "prop-types";


const HelpCard = ({ title, description, id, type }) => {
  return (
    <div className={"help-card"} card-id={id}>
      <div className={"help-card-header"}>
        <div>
          <div className={"help-card-title"}>{title}</div>
          {type && <div className={"help-card-type"}>{type}</div>}
        </div>
      </div>
      <div className={"help-card-description"}>
        <span style={{ fontWeight: 500 }}>Description:</span>
        <div>{description}</div>
      </div>
    </div>
  );
};

HelpCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
};

export default HelpCard;